export const OptionGroupsTableColumns = [
    { id: 'name', labelEn: 'Name', labelAr: 'الاسم', align: 'start' },
    { id: 'code', labelEn: 'Code', labelAr: 'الكود', align: 'start' },
    { id: 'display_type', labelEn: 'Display Type', labelAr: 'نوع العرض', align: 'center' },
    { id: 'values', labelEn: 'Values', labelAr: 'القيم', align: 'start' },
    { id: 'status', labelEn: 'Status', labelAr: 'الحالة', align: 'center' },
];
